import { useEffect } from 'react'
import { createScreenWakeLock } from '../services/screen-wake-lock'
import { vclog } from './vc-log'

/**
 * Keeps the screen on for as long as the calling component is mounted, so a
 * phone does not lock mid-meeting with the camera off. See
 * services/screen-wake-lock.
 */
export function useScreenWakeLock(): void {
  useEffect(() => {
    const lock = createScreenWakeLock({
      onEvent: (event) => {
        const { type, ...data } = event
        vclog('screen', `wake lock ${type}`, data)
      },
    })
    return () => lock.dispose()
  }, [])
}
